module.exports = __webpack_public_path__ + "static/picking-d55bb0ed2ce8db7b2a4d8dec364aa0cf.svg";